import { useLocation, useNavigate } from "react-router-dom";

export function useAppNavigate() {
  const navigate = useNavigate();
  const location = useLocation();



  const getAffiliatePathSegment = () => {
    const match = location.pathname.match(/\/partners\/([^/?#]+)/);
    return match ? `/partners/${match[1]}` : "";
  };

  const getPreservedQuery = () => {
    const currentParams = new URLSearchParams(location.search);
    const preservedParams = new URLSearchParams();

    const ref = currentParams.get("ref");
    const promo = currentParams.get("promo");

    if (ref) preservedParams.set("ref", ref);
    if (promo) preservedParams.set("promo", promo);

    return preservedParams;
  };

  const appNavigate = (path, options = {}) => {
    const [pathname, existingQueryString] = path.split("?");
    const preserveAffiliatePath = options?.preserveAffiliatePath !== false;
    const existingQuery = new URLSearchParams(existingQueryString || "");
    const preservedQuery = getPreservedQuery();

    // Add preserved query params (ref, promo) if not present
    preservedQuery.forEach((value, key) => {
      if (!existingQuery.has(key)) {
        existingQuery.set(key, value);
      }
    });

    // Add /partners/:code at the end if not present
    const finalPathname = (() => {
      if (pathname === '/') {
        const currentAffiliateSegment = getAffiliatePathSegment();
        return currentAffiliateSegment || '/';
      }
      if (preserveAffiliatePath && !pathname.includes('/partners/')) {
        return `${pathname.replace(/\/+$/, '')}${getAffiliatePathSegment()}`;
      }
      return pathname;
    })();

    const finalPath = `${finalPathname}${existingQuery.toString() ? `?${existingQuery.toString()}` : ""}`;

    navigate(finalPath, options);
  };

  return appNavigate;
}
